import React, { Component } from 'react';

import {
  HomeSlider,
  HomeTitle,
  Img,
  CoverSection,
  ResponsiveYouTubeIframe,
} from '../../Components/UI/UI';

import { getWeather, asyncgetWeather, isMobile } from '../../Utility/Utility';

import Menu from '../../Components/Menu/Menu';
import Footer from '../../Components/Footer/Footer';

import './CoronaVirus.css';

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
      const weather = response[0];
      // console.log( typeof weather);
      // console.log( weather);
    
      var weather2 = weather;

      
      if (typeof weather === 'string' && weather.includes("float")) {
        // Variable is a string
        // console.log('Is float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);

      
      } else if (typeof weather === 'object' && weather !== null) {
        // Variable is an object
        // console.log('Variable is an object');
        weather2 = weather.data;
        // console.log(weather2);
       
      } else if (typeof weather === 'string' && !weather.includes("float")){
        // console.log('Is NOt  float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);
     
      }

      //  else {
      //   // Variable is neither a string nor an object
      //   console.log('Variable is neither a string nor an object');
      // }

      this.setState({ 
        deadSeaWeather: weather2.deadsea.temperature,
        jerusalemWeather: weather2.jerusalem.temperature,
        telAvivWeather: weather2.telaviv.temperature,
        waterTemp: weather2.telaviv.water_temp,
      });
    });

    window.addEventListener('resize', this.updateDimensions);
  }

  render() { 
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        {!isMobile() ? (
          <CoverSection
            desktopImg={'/HomeSlider/corona.jpg'}
            mobileImg={'/HomeSlider/M/uk/4.jpg'}
            cssClass={'north'}
            waterTemp={this.state.waterTemp}
            telAvivWeather={this.state.telAvivWeather}
            jerusalemWeather={this.state.jerusalemWeather}
          />
        ) : (
          <div className="ac-corona-mobile-video">
            <ResponsiveYouTubeIframe vidId={'yE5MV_10cZw'} />
          </div>
        )}

<div className="container">
             
             <div className="ac-new-container">
             <div className="ac-new-container">
 <h2 className="ac-pink"></h2>
 <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">Willkommen zurück</h2>
 <h2><span><strong>Reisen nach Israel für vollständig geimpfte Ausländer</strong></span></h2><br/>
 Ab dem 1. November 2021 dürfen ausländische Staatsangehörige, die vollständig geimpft sind, unter folgenden Bedingungen nach Israel einreisen:
 <ul>
    <li>1. Personen, die sich in den letzten 14 Tagen vor der Einreise nach Israel nicht in einem roten Land aufgehalten haben.</li>
    <li>2. Personen, die mit einem von der Weltgesundheitsorganisation (WHO) zugelassenen Impfstoff geimpft sind, unterliegen den nachstehenden Bedingungen.</li>
    <li>3. Die Einreise darf ausschließlich über den Flughafen Ben Gurion erfolgen. </li>
    <li>4. Es gibt kein anderes Hindernis für Ihre Einreise nach Israel. </li>
    <li>5. Ausländische Staatsangehörige, die die oben genannten Bedingungen nicht erfüllen, können dennoch über das <a href="https://survey.gov.il/he/PCR2" target="_blank" rel="noopener">Ausnahmekomitee (Exceptions Committee)</a> die Einreise nach Israel beantragen.</li>
 </ul>
 <h2 className="ac-pink">Zugelassene Impfstoffe</h2><br/>
 <p className="ac-align-left-15">Die folgenden Impfstoffe sind von Israel zugelassen: Moderna, Biontec/Pfizer, Johnson & Johnson – Janssen, AstraZeneca, Covishield, Sinopharm, Sinovac, SputniK-V (vorbehaltlich der nachstehenden Bedingungen).</p>
 <br/>
 <p className="ac-align-left-15"><strong>Welche Personen gelten in Israel als vollständig geimpft?</strong></p>
 
 <p className="ac-align-left-15">Mit Biontec /Pfizer / Moderna / AstraZeneca / Sinovac oder Sinopharm geimpfte Ausländer:</p>
 <ul>
    <li>● Wenn Sie zwei Impfungen erhalten, müssen mindestens 14 Tage seit zweiter Impfung bei der Einreise nach Israel vergangen sein. (Jedoch nicht mehr als 180 Tage darf bei Ausreise aus Israel zurückliegen).</li>
    <li>● Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens 14 Tage vor der Einreise erfolgt ist.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15"> Mit dem Johnson & Johnson-Janssen-Impfstoff geimpfte Ausländer:</p>
 <ul>
    <li>● Vor Einreise nach Israel müssen mindestens 14 Tage seit der Impfung vergangen sein. (Die Impfung darf bei Ausreise aus Israel maximal 180 Tage zurückliegen).</li>
    <li>● Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens vor 14 Tagen erfolgt ist.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15">Mit dem Sputnik-Impfstoff geimpfte Ausländer:</p>
 <ul>
    <li>● Ausländer, die mit dem Sputnik-Impfstoff geimpft wurden, seit 15.11.21 und die in einem serologischen COVID-Antikörpertest in Israel positiv getestet wurden (Sie müssen isoliert werden, bis ein positives Ergebnis vorliegt).</li>
    <li>● Sie müssen zwei Impfungen erhalten, und es müssen mindestens 14 Tage seit der zweiten Impfung bei der Einreise nach Israel vergangen sein. (Jedoch nicht mehr als 180 Tage bei Ausreise aus Israel).</li>
    <li>● Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens vor 14 Tagen erfolgt ist.</li>
 </ul>
 <h2><strong>Einreise nach Israel für Personen, die sich vollständig von COVID erholt haben</strong></h2><br/>
 <p className="ac-align-left-15">Ausländische Staatsangehörige, die sich von COVID erholt haben, dürfen nach Israel einreisen, wenn sie ein digitales Zertifikat besitzen, das vom Israelisches Gesundheitssystem  digital verifiziert werden kann und auf einem positiven Ergebnis in einem Nukleinsäureamplifikationstest (NAAT) (molekularer Test ähnlich der Polymerase-Kettenreaktion (PCR) basiert.</p>
 <ul>
    <li>● Bei der Einreise nach Israel müssen seit dem positiven Testergebnis mindestens 11 Tage vergangen sein (aber nicht mehr als 190 Tage nach der Ausreise aus Israel).</li>
    <li>● Die Impfung muss mit einem von der Weltgesundheitsorganisation (WHO) zugelassenen Impfstoffe erfolgt sein.</li>
 </ul>
 <a href="#_ednref1" name="_edn1"></a>
 
 <b>* Entry for recoverees is only applicable for those coming from countries that issue certificates that the Israeli MOH systems can digitally authenticate, which is not available for people traveling from the USA or Canada</b>
 
 <h2><strong>Der Prozess der Einreise nach Israel</strong></h2>
 <br/>
 <ul className="ac-wrpr-num">
    <li className="ac-num-li">1. Sie müssen höchstens 72 Stunden vor Ihrem Flug einen Polymerase-Kettenreaktion (PCR)-Test durchführen.</li>
    <li className="ac-num-li">2. Sie müssen vor der Einreise nach Israel eine Passagiererklärung ausfüllen.
 <ul>
    <li>● Passagiere, die über ein überprüfbares digitales Zertifikat verfügen, sollten ihre Impf- oder Genesungszertifikat scannen oder auf das Formular für ankommende Passagiere hochladen und vor dem Einsteigen in das Flugzeug einen "Grünen Pass" erhalten.</li>
    <li>● Passagiere, die kein überprüfbares digitales Zertifikat haben, geben ihren Impfstatus im Formular für ankommende Passagiere an und füllen einen Antrag zur Verkürzung der Isolationszeit aus. Dann fügen sie die entsprechenden Dokumente bei, um vor dem Einsteigen in das Flugzeug einen grünen Pass zu erhalten.</li>
 </ul>
 </li>
    <li className="ac-num-li">3. Beim Einsteigen in das Flugzeug müssen folgende Dokumente vorgelegt werden.
 <ul>
    <li>● Dokumentation eines negativen Polymerase-Kettenreaktion (PCR)-Tests, der bis zu 72 Stunden vor dem Flug durchgeführt wurde.</li>
    <li>● Bestätigung der Abgabe einer ankommenden Passagiererklärung.</li>
    <li>● Impfbescheinigung über die Durchführung von Impfungen gemäß den vorstehenden Bestimmungen.</li>
    <li>● Wiederherstellungsbescheinigung, die vom Israelischen Gesundheitssystem digital verifiziert werden kann und auf eine Erholung gemäß den oben genannten Bestimmungen hinweist.</li>
    <li>● Ein digitales Zertifikat, das die Erholung von COVID gemäß den obigen Bestimmungen bestätigt. </li>
    <li>● Ausnahmegenehmigung des israelischen Innenministeriums (Gilt für Sonderfälle, geplante Reisen und für Gruppen)</li>
 </ul>
 </li>
    <li className="ac-num-li">4. Die Bevölkerungsbehörde am Flughafen Ben Gurion führt stichprobenartige Dokumentationsüberprüfung durch.</li>
    <li className="ac-num-li">5. Bei der Landung am Flughafen Ben Gurion muss ein Polymerase-Kettenreaktion (PCR)-Test durchgeführt werden. Sie müssen sich in Isolation begeben, bis ein negatives Ergebnis vorliegt, oder für 24 Stunden, je nachdem, was früher eintritt.</li>
    <li className="ac-num-li">6. Reisende, die mit Sputnik-Impfstoffen geimpft wurden, unterziehen sich einem serologischen Test am Flughafen Ben Gurion und isolieren sich bis zum positiven Testergebnis. (Dies wird zusätzlich zur Isolierung bis zum negativen Ergebnis des Polymerase-Kettenreaktion (PCR)-Tests bei der Landung durchgeführt).</li>
 </ul>
 <br/>
 <p className="ac-align-center">Für die Liste der Länder, die Zertifikate ausstellen, die vom Israelisches Gesundheitssystem digital verifiziert werden kann<br/>
 <a href="https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en" target="_blank" rel="noopener" className="ac-align-center">https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en</a></p><br/>
 <p  className="ac-align-center">Für die vollständigen Angaben zum Eingabeprotokoll klicken Sie hier:<br/>
 <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-left-15" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p><br/>
 <p  className="ac-align-center"><strong><span>· Die oben genannten Richtlinien sind hier zu Ihrer Information aufgeführt. Im Zweifelsfall lesen Sie bitte hierzu die auf der Website des israelischen Gesundheitsministeriums veröffentlichten Richtlinien, da die dortigen Informationen die aktuellen und genauesten sind.</span>
 </strong><br/> <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-center" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p>
 
 <h2 className="ac-pink">Bis bald in Israel</h2>
 
 </div>
 
 <div className="ac-inner-video">
   <ResponsiveYouTubeIframe vidId={'LSb4Lmuw_Kw'}/>
 </div>
 </div>
 
           </div>
 
 
           
         <Footer />
       </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js